import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Chip,
  Box,
  Stack
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
import { elapsedTimeToStr, getElapsedSeconds } from '../../../utils/formatTime';
import { RunningStateChip, RackLifecycleButton } from '.';

function formatElapsedTime(time) {
  const elapsed = getElapsedSeconds(time);
  return elapsedTimeToStr(elapsed);
}

function formatCountdown(seconds) {
  if (seconds === null || seconds === undefined) {
    return 'Disabled';
  }
  if (seconds < 0) {
    return 'Past due';
  }
  return elapsedTimeToStr(seconds).trim();
}

RackLifecycleInfo.propTypes = {
  rackDetails: PropTypes.object
};

export default function RackLifecycleInfo({ rackDetails }) {
  const { isAdmin } = useSelector((state) => state.userDetails.value);
  const inactivity = rackDetails.lifecycle?.inactivity_policy;

  return (
    <Card data-testid="rack-lifecycle-info">
      <CardHeader
        title="Lifecycle"
        action={
          <Stack direction="row" spacing={1} alignItems="center">
            {isAdmin && <RackLifecycleButton rackName={rackDetails.name} />}
            <RunningStateChip runningState={rackDetails.running.state} />
          </Stack>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography variant="overline">Last Accessed</Typography>
              <Chip
                label={formatElapsedTime(rackDetails.last_accessed)}
                size="small"
                variant="outlined"
                color="primary"
              />
            </Stack>
          </Grid>
          {inactivity?.time_till_shutdown > 0 ? (
            <Grid item xs={12}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography variant="overline">Auto Stop In</Typography>
                <Chip
                  label={formatCountdown(inactivity?.time_till_shutdown)}
                  size="small"
                  variant="outlined"
                  color="primary"
                />
              </Stack>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography variant="overline">Auto Delete In</Typography>
                <Chip
                  label={formatCountdown(inactivity?.time_till_delete)}
                  size="small"
                  variant="outlined"
                  color="primary"
                />
              </Stack>
            </Grid>
          )}
        </Grid>
        <Alert severity="info" sx={{ mt: 2 }}>
          To modify lifecycle policies, please contact the Virtual Rack team.
        </Alert>
      </CardContent>
    </Card>
  );
}
